import React, { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import ProofBar from './components/ProofBar';
import ComplianceSection from './components/ComplianceSection';
import TrustSection from './components/TrustSection';
import ProblemSection from './components/ProblemSection';
import FeaturesSection from './components/FeaturesSection';
import ModulesSection from './components/ModulesSection';
import GapSection from './components/GapSection';
import WhoItsForSection from './components/WhoItsForSection';
import ProofSection from './components/ProofSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import SignupFormPage from './components/SignupFormPage';
import SignupPage from './components/SignupPage';
import PlatformPage from './components/Platform/PlatformPage.jsx';
import CompanyPage from './components/Company/CompanyPage.jsx';
import ResourcesPage from './components/Resources/ResourcesPage.jsx';
import BlogPostPage from './components/Blog/BlogPostPage.jsx';
import ContactPage from './components/ContactPage.jsx';
import DemoBookingPage from './components/DemoBookingPage.jsx';
import PricingPage from './components/Pricing/PricingPage';

function Home() {
    const location = useLocation();
    const navigate = useNavigate();
    const { hash, state } = location;

    useEffect(() => {
        if (hash) {
            const id = hash.replace('#', '');
            const el = document.getElementById(id);
            if (el) {
                const headerOffset = 80;
                const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        }
    }, [hash]);

    useEffect(() => {
        const sectionId = state?.homeSection;
        if (!sectionId || typeof sectionId !== 'string') return;
        const el = document.getElementById(sectionId);
        if (el) {
            const headerOffset = 80;
            const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
        navigate(location.pathname, { replace: true, state: {} });
    }, [state?.homeSection, navigate, location.pathname]);

    return (
        <>
            <Header />
            <Hero />
            <ProofBar />
            <TrustSection />
            <ProblemSection />
            <FeaturesSection />
            <ModulesSection />
            <GapSection />
            <WhoItsForSection />
            <ProofSection />
            <ComplianceSection />
            <CTASection />
            <Footer />
        </>
    );
}

function App() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        window.__MEDZHUB_SEO__?.apply(pathname);
    }, [pathname]);

    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/signupform" element={<SignupFormPage />} />
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/platform" element={<PlatformPage />} />
                <Route path="/company" element={<CompanyPage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/blog" element={<Navigate to="/resources" replace />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/demo" element={<DemoBookingPage />} />
                <Route path="/pricing" element={<PricingPage />} />
            </Routes>
        </div>
    );
}

export default App;

